import { ItineraryFragment } from 'generated/graphql';
import { DurationRange } from '../Provider';
import { getItineraryDuration } from '../../../../../clientState/providers/ParsedSearchResponseProvider/index';

type SemDurationFilterCollectorReturnType = {
  add: (itinerary: ItineraryFragment) => void;
  build: () => DurationRange;
};
const SemDurationFilterCollector = (): SemDurationFilterCollectorReturnType => {
  const initialValues = [0, 0];
  return {
    add(itinerary: ItineraryFragment): void {
      const itineraryDuration = getItineraryDuration(itinerary?.legs || []);
      if (initialValues[0] === 0) {
        initialValues[0] = itineraryDuration;
        initialValues[1] = itineraryDuration;
      } else if (
        itineraryDuration > initialValues[0] &&
        itineraryDuration > initialValues[1]
      )
        initialValues[1] = itineraryDuration;
      else if (itineraryDuration < initialValues[0])
        initialValues[0] = itineraryDuration;
    },
    build(): DurationRange {
      return { minDays: initialValues[0], maxDays: initialValues[1] };
    },
  };
};

export default SemDurationFilterCollector;
